import api from "../../../services/api";

export const fetchMultiChannel = async (period: number) => {
  const { data } = await api.get("/api/managerial/multi_channel", {
    params: { period },
  });
  return data;
};
